import { Tooltip } from 'antd'
import { timeAgo } from '../util'
import React, { useEffect, useReducer } from 'react'
import { useAuth } from '../auth'

export function TimeAgo({ date }: { date: Date }) {
    const [, forceUpdate] = useReducer((x) => x + 1, 0)
    const { user } = useAuth()

    const locale = (user?.locale || '').split('_')[0]

    useEffect(() => {
        const isLessThanMinute = () => {
            const diffInSeconds = Math.floor((Date.now() - date.getTime()) / 1000)
            return diffInSeconds <= 60
        }

        if (!isLessThanMinute()) {
            return
        }

        const interval = setInterval(() => {
            if (!isLessThanMinute()) {
                clearInterval(interval)
                return
            }
            forceUpdate()
        }, 1000)

        return () => clearInterval(interval)
    }, [forceUpdate, date])

    return (
        <Tooltip title={date.toLocaleString(locale, { dateStyle: 'medium', timeStyle: 'short' })}>
            {timeAgo(date, locale)}
        </Tooltip>
    )
}
